import React, { useState, useEffect } from 'react';
import withTranslations from 'app/components/HOGs/withTranslations';

import * as way from 'app/libs/core/PubSubWays';
import { publish } from 'app/libs/core/PubSub';

import { Switch, Checkbox, notification } from 'antd';
import { DownOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';

import { CreateTourPlaceType } from 'app/constants/place.constant';

import './ShowPlaces.css';
import { useSelector } from 'react-redux';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import { pageScope } from 'app/constants/mapConstants';
import { getPlaceCategory } from '../../Places/place.utils';

const ShowPlaces = ({ tr }) => {
  const { setPlaceVisibleData, PlaceFetchListData, MyPlaceFetchListData } =
    useActions();

  const visible = useSelector(
    (store) => store.tourFullData.isPlaceVisible.visible
  );
  const type = useSelector((store) => store.tourFullData.isPlaceVisible.type);
  const placeList = useSelector((store) => store.placesData.placeList);
  const placesIdInCreate = useSelector(
    (store) => store.placesData.placesIdInCreate
  );
  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);
  const activeTourTab = useSelector(
    (store) => store.tourFullData.activeTourTab
  );
  const multiDay = useSelector((store) => store.tourFullData.data.multiDay);

  const [show, setShow] = useState(false);

  const fetchData = () => {
    if (type === CreateTourPlaceType.My) {
      if (isLoggedIn) {
        MyPlaceFetchListData();
      } else {
        const args = {
          message: tr['Login to see your places'],
          duration: 0,
          top: 80,
        };
        notification.warning(args);
      }
    } else {
      PlaceFetchListData();
    }
  };

  const clearData = () => {
    publish(way.DRIVE_BUILDER_PLACE_CLEAR, {});
  };

  const updatePlaceIcons = (clear = false) => {
    publish(way.DRIVE_BUILDER_PLACE_CLEAR, {});
    if (placeList && placeList.length > 0 && !clear) {
      placeList
        .filter((item) => !placesIdInCreate.includes(item.id))
        .forEach((point) => {
          publish(way.DRIVE_BUILDER_PLACE_CREATE, {
            customId: point.id,
            isLoading: false,
            point: {
              ...point,
              iconType: getPlaceCategory(point.options),
              scope: pageScope.place,
              pointScope: pageScope.place,
            },
          });
        });
    }
  };

  useEffect(() => {
    return () => {
      updatePlaceIcons(true);
    };
  }, []);

  useEffect(() => {
    if (placeList && placeList.length > 0) {
      updatePlaceIcons();
    } else {
      updatePlaceIcons(true);
    }
  }, [placeList, placesIdInCreate]);

  useEffect(() => {
    clearData();
    if (visible) {
      fetchData();
    }
  }, [visible, type]);

  const changeVisible = (isEnable) => {
    setPlaceVisibleData({ type: 'visible', data: isEnable });
  };

  const onChange = (type) => {
    setPlaceVisibleData({ type: 'type', data: type });
  };

  const getUnactiveColor = (val) => (val ? '#333333' : '');

  return !multiDay || (multiDay && +activeTourTab !== 0) ? (
    <div className="show_places">
      <div className="header">{tr.Places}</div>
      <div className="places_title">
        <div className="main">
          <span className="text">{tr['Show Places']}</span>
        </div>
        <div className="switch">
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={visible}
            onChange={(val) => changeVisible(val)}
          />
        </div>
        <div className="icon_arrow" onClick={() => setShow(!show)} aria-hidden>
          <DownOutlined />
        </div>
      </div>
      {visible || show ? (
        <div className="places_types">
          <div className="item">
            <div className="main">
              <span
                className="text"
                style={{ color: getUnactiveColor(!visible) }}
              >
                {tr['My Places']}
              </span>
            </div>
            <div className="sub_check">
              <Checkbox
                checked={type === CreateTourPlaceType.My}
                onChange={() => onChange(CreateTourPlaceType.My)}
                disabled={!visible}
              />
            </div>
          </div>
          <div className="item">
            <div className="main">
              <span
                className="text"
                style={{ color: getUnactiveColor(!visible) }}
              >
                {tr['Public Places']}
              </span>
            </div>
            <div className="sub_check">
              <Checkbox
                checked={type === CreateTourPlaceType.Public}
                onChange={() => onChange(CreateTourPlaceType.Public)}
                disabled={!visible}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  ) : null;
};

export default withTranslations(ShowPlaces);
